import moment from 'moment';

export interface BrandStockForTooltip {
    available: number;
    backorder?: {
        available: number;
        deliveryFrom: Date | string | null;
        deliveryTo: Date | string | null;
    };
}

export interface TooltipLabels {
    available: string;
    backorder?: string;
    backorderSingular?: string;
}

export function getBrandStockTooltipText(
    brandStock: BrandStockForTooltip,
    labels: TooltipLabels
): { available: string; backorder: string } | undefined {
    if (!brandStock?.backorder?.available) {
        return undefined;
    }

    const { deliveryTo, deliveryFrom, available } = brandStock.backorder;

    const formattedToDate = moment(deliveryTo);
    const formattedFromDate = moment(deliveryFrom);

    if (!formattedToDate.isValid() || !formattedFromDate.isValid()) {
        console.warn(`Invalid date format for backorder delivery: from ${deliveryFrom} to ${deliveryTo}`);
        return undefined;
    }

    const backorderLabel = available === 1 ? labels.backorderSingular : labels.backorder;
    if (!backorderLabel) {
        return undefined;
    }

    return {
        available: labels.available.replace('{{number}}', String(brandStock.available)),
        backorder: backorderLabel
            .replace('{{number}}', String(available))
            .replace('{{fromDate}}', formattedFromDate.format('DD.MM.YYYY'))
            .replace('{{toDate}}', formattedToDate.format('DD.MM.YYYY'))
    };
}
